import { render, staticRenderFns } from "./AwardTrophyList.vue?vue&type=template&id=7b8c0e14&scoped=true&"
import script from "./AwardTrophyList.vue?vue&type=script&lang=js&"
export * from "./AwardTrophyList.vue?vue&type=script&lang=js&"
import style0 from "./AwardTrophyList.vue?vue&type=style&index=0&id=7b8c0e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8c0e14",
  null
  
)

export default component.exports